module.exports = __webpack_public_path__ + "img/26.53b839c6.jpg";